<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  emptyStateMessage: {
    type: String,
    default: '',
  },
  showActions: {
    type: Boolean,
    default: true,
  },
});

const router = useRouter();
const { t } = useI18n();
const { accountScopedRoute } = useAccount();
const uiFlags = useMapGetter('notifications/getUIFlags');

const emptyMessage = computed(
  () => props.emptyStateMessage || t('INBOX.LIST.EMPTY_DESCRIPTION')
);

const openQueue = routeName => router.push(accountScopedRoute(routeName));
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full text-center bg-n-surface-1 lg:flex"
  >
    <div v-if="uiFlags.isFetching" class="flex justify-center my-4">
      <Spinner class="text-n-brand" />
    </div>
    <div v-else class="flex max-w-md flex-col items-center gap-5 px-8">
      <div
        class="flex size-14 items-center justify-center rounded-full bg-n-alpha-2 text-n-slate-11"
      >
        <span class="i-lucide-bell size-6" />
      </div>
      <div class="flex flex-col items-center gap-1.5">
        <h2 class="text-heading-2 text-n-slate-12">
          {{ $t('INBOX.LIST.NO_NOTIFICATIONS') }}
        </h2>
        <p class="text-sm leading-6 text-n-slate-10">
          {{ emptyMessage }}
        </p>
      </div>
      <div v-if="showActions" class="flex items-center gap-2">
        <NextButton
          :label="$t('INBOX.LIST.OPEN_CONVERSATIONS')"
          icon="i-lucide-message-circle"
          @click="openQueue('home')"
        />
        <NextButton
          :label="$t('INBOX.LIST.REVIEW_UNATTENDED')"
          icon="i-lucide-clock-alert"
          slate
          @click="openQueue('conversation_unattended')"
        />
      </div>
    </div>
  </div>
</template>
